<template>
  <div class="row">
    <div class="col-8 h-100">
      <breadcrumb :page="page" />
    </div>
    <div class="col-4 text-right">
      <button tag="button" class="btn btn-green" @click="goBack()">
        <i class="fas fa-arrow-circle-left" />
        <span class="pl-2">Regresar</span>
      </button>
      <button
        v-if="isDraft"
        tag="button"
        class="btn btn-green"
        :disabled="isRegressionPlanillaBlockingForm"
        @click="save()"
      >
        <i class="fas fa-save" />
        <span class="pl-2">Guardar</span>
      </button>
    </div>
    <div class="col-12">
      <ValidationObserver ref="form" v-slot="{ dirty, valid }">
        <SaveObserver :dirty="dirty">
          <ValidationProvider
            v-slot="{ errors }"
            name="(área)"
            rules="required"
            eager
          />
          <div class="dropdown-divider mt-0 pb-2 w-100" />
          <div class="tab">
            <div class="panel-simple">
              <!--Comienzo cuestionario año escolar extendido-->
              <SectionTitle
                content="Indique los servicios educativos y relacionados o áreas del PEI que requieren ser implementadas durante el año escolar extendido, así como la frecuencia de los mismos"
                :has-line="true"
              />

              <div class="panel-simple">
                <div class="row ml-2">
                  <div class="col-3">
                    <span><strong>Área:</strong></span>
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="(área)"
                      rules="required"
                      eager
                    >
                      <CustomDropDown
                        v-model="model.selectArea"
                        placeholder="Seleccionar"
                        fieldkey="id"
                        required
                        :error="errors[0]"
                        :custom-error-msg="errors[0]"
                        fieldname="name"
                        :options="areas"
                        :disabled="!isDraft || isEditOrView"
                      />
                    </ValidationProvider>
                  </div>
                  <div v-if="!isEducativo" class="col-1" />
                  <div v-if="!isEducativo" class="col-3 mt-2">
                    <div class="row">
                      <span>
                        <strong>Frecuencia:</strong>
                      </span>
                    </div>
                    <div class="row">
                      <span>{{ model.peiFrequency }}</span>
                    </div>
                  </div>
                  <div v-if="isEducativo" class="col-3">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Frecuencia"
                      rules="required"
                    >
                      <CustomDropDown
                        v-model="model.peiFrequencyCode"
                        :options="frequencyList"
                        fieldkey="id"
                        fieldname="name"
                        placeholder="Seleccione"
                        label="Frecuencia:"
                        class="block-spacing"
                        :error="errors[0]"
                        custom-error-msg="Seleccione la frecuencia del servicio."
                        :disabled="!isDraft || isRegressionPlanillaBlockingForm"
                      />
                    </ValidationProvider>
                  </div>

                  <div v-if="isEducativo" class="col-2 left-space">
                    <div class="row">
                      <span>
                        <strong>Inicio de fecha:</strong>
                      </span>
                    </div>
                    <div class="row">
                      <CustomDatePicker
                        v-model="model.fromDate"
                        :disabled="true"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="panel-simple">
                <div class="row ml-2">
                  <div class="col-3">
                    <span v-if="!isEducativo"><strong>Modalidad:</strong></span>
                    <div class="row  ml-1">
                      <span v-if="!isEducativo">{{ model.modalityName }}</span>
                    </div>
                  </div>
                  <div v-if="!isEducativo" class="col-1" />
                  <div v-if="!isEducativo" class="col-3">
                    <div class="row">
                      <span>
                        <strong>Duración:</strong>
                      </span>
                    </div>
                    <div class="row">
                      <span v-if="!isEducativo && areaDetail.detail">
                        {{ areaDetail.detail.peiDuration }}
                      </span>
                    </div>
                  </div>
                  <div v-if="isEducativo" class="col-3">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Duración"
                      rules="required"
                    >
                      <CustomDropDown
                        v-model="model.peiDurationCode"
                        :options="durationList"
                        fieldkey="id"
                        fieldname="name"
                        label="Duración:"
                        placeholder="Seleccione"
                        class="block-spacing"
                        :error="errors[0]"
                        custom-error-msg="Seleccione la duración del servicio."
                        :disabled="!isDraft || isRegressionPlanillaBlockingForm"
                      />
                    </ValidationProvider>
                  </div>

                  <div v-if="isEducativo" class="col-2 left-space">
                    <div class="row">
                      <span>
                        <strong>Cierre de fecha:</strong>
                      </span>
                    </div>
                    <div class="row">
                      <CustomDatePicker
                        v-model="model.toDate"
                        :disabled="true"
                      />
                    </div>
                  </div>
                  <div
                    v-if="canShowRegressionCompensatoryRequestNumberField"
                    class="col-3"
                  >
                    <div class="row">
                      <span>
                        <strong>Número de Planilla de Regresión:</strong>
                      </span>
                    </div>
                    <div class="row">
                      <span>
                        {{
                          regressionCompensatoryRequestNumber || 'No disponible'
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-4">
                <span>
                  <strong>Cometario:</strong>
                </span>

                <ValidationProvider
                  v-slot="{ errors }"
                  name="comentario"
                  rules="required"
                >
                  <CustomTextArea
                    :id="'commentArea'"
                    v-model="model.extendedDescription"
                    style="width:100%"
                    :maxlength="maxchars"
                    :error="errors[0]"
                    :custom-error-msg="errors[0]"
                    :disabled="!isDraft || isRegressionPlanillaBlockingForm"
                    placeholder="Escribir comentario..."
                  />
                </ValidationProvider>
              </div>
              <div v-if="model.serviceStatusesInfo.length > 0">
                <ServiceStatusInfo
                  :key="model.serviceStatusesInfo.length"
                  class="mt-3"
                  :services="model.serviceStatusesInfo"
                />
              </div>
              <div v-if="isEducativo && showQuestion" class="col-12 mt-4">
                <strong>
                  <strong>
                    ¿El servicio que está ofreciendo en esta área es tiempo
                    compensatorio?
                  </strong>
                </strong>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="(tiempo compensatorio)"
                  rules="required"
                >
                  <div class="d-inline-flex">
                    <div class="input-group">
                      <input
                        id="input1"
                        v-model="model.isCompensatoryTime"
                        type="radio"
                        class="hidden"
                        name="inputs"
                        :value="true"
                        :disabled="!isDraft || isRegressionPlanillaBlockingForm"
                      />
                      <label class="entry" for="input1">
                        <div class="circle" />
                        <div class="entry-label">Si</div>
                      </label>

                      <input
                        id="input2"
                        v-model="model.isCompensatoryTime"
                        type="radio"
                        class="hidden"
                        name="inputs"
                        :value="false"
                        :disabled="!isDraft || isRegressionPlanillaBlockingForm"
                      />
                      <label class="entry" for="input2">
                        <div class="circle" />
                        <div class="entry-label">No</div>
                      </label>
                      <div
                        v-if="model.isCompensatoryTime != null"
                        class="highlight"
                      />
                    </div>
                  </div>
                  <Error
                    v-if="errors && errors.length > 0"
                    variant="no-border"
                    :message="errors[0]"
                  />
                </ValidationProvider>
              </div>

              <div
                v-if="isEducativo && model.isCompensatoryTime"
                class="col-12 mt-4"
              >
                <div class="form-row">
                  <div class="col-auto">
                    <label class="col-form-label" for="inlineFormInput">
                      <strong>
                        ¿Cuánto tiempo se le adeuda al estudiante en esta área?
                      </strong>
                    </label>
                    <ValidationProvider v-slot="{ errors }" name="(adeuda)">
                      <input
                        id="inlineFormInput"
                        v-model="model.timeDebtedQty"
                        type="number"
                        class=" number-text form-control"
                        style="font-weight: normal;"
                        min="1"
                        eager
                        :disabled="!isDraft || isRegressionPlanillaBlockingForm"
                      />
                      <Error
                        v-if="errors && errors.length > 0"
                        variant="no-border"
                        :message="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div v-if="model.selectArea">
                <div
                  v-if="
                    isRequiredTransportQuestionnary &&
                      canShowTransportationSectionForPS &&
                      !disabledRequiredTransportation &&
                      (!canShowServiceStatusSection ||
                        canShowTransportationSection)
                  "
                  class="row mt-5"
                >
                  <div class="col">
                    <SectionTitle
                      :content="'Información de Transportación'"
                      :has-line="true"
                    />
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="transportación"
                      rules="required"
                      mode="eager"
                    >
                      <WizardQuestion
                        id="qQuestions"
                        :ref="'transportation'"
                        v-model="model.transportation.wasRequested"
                        description="¿El estudiante requiere transportación?"
                        :disabled="
                          areaDetail.detail || isRegressionPlanillaBlockingForm
                        "
                        :is-disabled="
                          !isDraft || isRegressionPlanillaBlockingForm
                        "
                        :answer-control-type="1"
                        :has-icon="true"
                        :icon="'fa fa-bus'"
                        :is-required="false"
                        error-message=""
                        require-error-message=""
                        :on-change="onChangeTranspInfo"
                      />
                      <Error
                        v-if="errors && errors.length > 0"
                        variant="no-border"
                        :message="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <div
                v-if="model.transportation.wasRequested"
                class="row separator-box0"
              >
                <div class="col">
                  <ServiceQuestionnaire
                    v-if="
                      requiredTransportation &&
                        transportRequestQuestion.length > 0
                    "
                    v-model="transportationModel"
                    :questionary-id="requiredTransportation.id"
                    :questions="transportRequestQuestion"
                    :is-valid="questionnaireValid"
                    :questionnaire-status="questionnaireStatus"
                    :questionary-number="
                      requiredTransportation.questionnaireNumber
                    "
                    :questionary-disabled="
                      !isDraft || isRegressionPlanillaBlockingForm
                    "
                    :transport-type="transportType"
                    :show-transport-type="showTransportType"
                    :is-therapy-service="!isEducativo"
                    :is-from-aee="true"
                    :pei-service-type-id="peiServiceTypeId"
                    @onTransportTypeChange="onTransportTypeChange"
                    @departure-change="onDepartureChange"
                    @location-change="onLocationChange"
                    @accompany-change="onAccompanyChange"
                    @special-equipment-change="onSpecialEquipmentChange"
                    @millaje-change="onMillajeChange"
                    @on-start-date-change="onStartDateChange"
                    @on-end-date-change="onEndDateChange"
                    @on-update="onUpdateQuestionnarie"
                    @on-edit="onEditHandler"
                  />
                </div>
              </div>
              <!--Fin cuestionario año escolar extendido-->
              <div class="my-5" />

              <div class="dropdown-divider end-green-line mt-5 w-100 " />
            </div>
          </div>
        </SaveObserver>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import SectionTitle from '@/components/pei/shared/SectionTitle.vue';
import WizardQuestion from '@/components/pei/WizardQuestion';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import SaveObserver from '@/components/common/SaveObserver';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomTextArea from '@/components/common/CustomTextArea';
import { ServiceQuestionnaire } from '@/components/pei/service/components/questionnaire';
import store from '@/store/index'; //Se debe coordinar si los components tendran acceso al store o no.
import peiStatus from '@/utils/constants/pei/peiStatus';
import peiProgramAreas from '@/utils/constants/pei/peiProgramAreas';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import alert from '@/mixin/alert.mixin';
import Error from '@/components/common/Error';
import academicYears from '@/utils/constants/academicYears';
import ServiceStatusInfo from '@/components/pei/service/components/ServiceStatusInfo';
import { mapGetters } from 'vuex';
import AdmissionStatuses from '@/utils/constants/thrpiesAdmissionStatuses';
import PeiAnalysisService from '@/utils/constants/pei/peiAnalysisService';
import transportationServiceAddressTypes from '@/utils/constants/pei/transportationServiceAddressTypes.js';
import {
  getSysparameterByNameAndAcademicYear,
  getSysparameterByNames,
} from '@/modules/system-parameter-managment/api';
import moment from 'moment';

const PHYSICAL_EDUCATION_SERVICE_CONTROL_CODE = 3;
const DEAF_SERVICE_CONTROL_CODE = 4;

import generalService from '@/services/pei/general';
export default {
  name: 'QuestionnaireAEE',
  mixins: [alert],
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Cuestionario Año Escolar Extendido ',
        routes: [
          'Inicio',
          'PEI',
          'Otras consideraciones y servicios (continuación)',
        ],
      },
      maxchars: 3000,
      isUpdate: false,
      requiredTransportation: null,
      evaluations: [],
      documents: [],
      questionnaireValid: true,
      questionnaireStatus: 'Pendiente',
      questionnaireState: true,
      showTransportType: false,
      transportType: '139', //1. No required, 2. Regular, 3.Carrier, 4.Scholarship
      transportRequestQuestion: [],
      peiId: store.getters.SelectedPei,
      peiStatus: peiStatus,
      peiProgramAreas: peiProgramAreas,
      model: {
        selectArea: null,
        areaId: 0,
        programServiceAreaId: 0,
        extendedDescription: '',
        fromDate: null,
        toDate: null,
        modalityName: null,
        peiFrequency: null,
        isCompensatoryTime: null,
        timeDebtedQty: null,
        analysisServiceDepartureCode: null,
        analysisServiceLocationCode: null,
        companionFlag: null,
        specialEquipmentCode: null,
        peiDurationCode: null,
        peiFrequencyCode: null,
        millaje: null,
        startDate: null,
        endDate: null,
        serviceStatusesInfo: [],
        analysisServiceControlVisualCode: null,
        transportation: {
          wasRequested: null,
          isCompletedFlag: false,
        },
        peiTransportationStatus: null,
      },
      transportationModel: {
        departureCode: 0,
        placeCode: 0,
        specialEquipmentCode: 0,
        acompanyCode: '',
        mileage: 0,
        startDate: '',
        endDate: '',
        peiAnalysisServiceCode: 0,
        justification: '',
        departure: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: null,
          phone: '',
          state: '',
          zipCode: '',
        },
        place: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: null,
          phone: '',
          state: '',
          zipCode: '',
        },
      },
      areaList: [],
      isEditOrView: false,
      durationList: [],
      frequencyList: [],
      disabledRequiredTransportation: false,
      peiAnalysisService: PeiAnalysisService,
      showRegressionCompensatoryRequestNumberField: false,
      regressionCompensatoryRequestNumber: '',
      regressionCompensatoryRequestNumberLoaded: false,
      // US 150589 — when true, therapy service and regression sheet validations are enabled
      hasTherapyServiceAeeOrRegressionSheetValidationEnabled: null,
      hasAnyEducativeServiceInAeeValue: null,
    };
  },
  components: {
    breadcrumb,
    SectionTitle,
    WizardQuestion,
    CustomTextArea,
    ServiceQuestionnaire,
    ValidationProvider,
    ValidationObserver,
    SaveObserver,
    CustomDropDown,
    CustomDatePicker,
    Error,
    ServiceStatusInfo,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onTransportTypeChange(newValue) {
      this.transportType = newValue;
      this.model.peiTransportationStatus = parseInt(newValue);
    },
    getAnalysisService() {
      const serviceAnalysisId = this.areaDetail?.detail?.serviceAnalysisId;
      if (!serviceAnalysisId) {
        return {};
      }
      return generalService.getAnalysisService(serviceAnalysisId);
    },
    async initDataService() {
      const { data: serviceData } = await this.getAnalysisService();

      if (serviceData) {
        store.dispatch('setPeiTransportationInfo', {
          departureCode: serviceData.peiAnalysisServiceDepartureCode,
          placeCode: serviceData.peiAnalysisServiceLocationCode,
          specialEquipmentCode: serviceData.peiSpecialEquipmentCode,
          acompanyCode: serviceData.companionFlag ? '1' : '0',
          millaje: serviceData.mileage,
          startDate: this.areaDetail.detail.fromDate,
          endDate: this.areaDetail.detail.toDate,
          peiAnalysisServiceCode: serviceData.peiAnalysisServiceCode,
          justification: serviceData.justification,
        });
        if (
          serviceData.visualControlCode ==
            PHYSICAL_EDUCATION_SERVICE_CONTROL_CODE ||
          serviceData.visualControlCode == DEAF_SERVICE_CONTROL_CODE
        ) {
          this.disabledRequiredTransportation = true;
        }
        this.model.serviceStatusesInfo = serviceData.serviceStatusesInfo;
        this.model.isTransportationLogicActive =
          serviceData.isTransportationLogicActive;
      }
    },
    async save() {
      await this.loadEnableTherapyServiceAeeOrRegressionSheetValidation();
      // US 150589 — validation enabled flag controls whether to skip blocking checks
      // When enabled is false, bypass validation (allow form submission without regression sheet)
      const bypassValidation = !this
        .hasTherapyServiceAeeOrRegressionSheetValidationEnabled;

      if (
        this.isRegressionPlanillaBlockingForm &&
        !bypassValidation &&
        !this.isEducativeService
      ) {
        this.ShowToast(
          'Atención',
          this.getRegressionPlanillaMissingMessage(),
          'error'
        );
        throw true;
      }
      if (!(await this.validate())) {
        this.ShowToast(
          'Atención',
          'Se requiere completar todos los campos para continuar',
          'error'
        );
      }
      if (
        this.requiredTransportation != null &&
        this.model.transportation.wasRequested &&
        !this.showTransportType
      ) {
        this.ShowToast(
          'Atención',
          'Debe contestar la sección de cuestionario para continuar.',
          'error'
        );
      }

      if (
        !(await this.validate()) ||
        (this.requiredTransportation != null &&
          this.model.transportation.wasRequested &&
          !this.showTransportType)
      ) {
        throw true;
      }
      const data = { ...this.model };
      const areaDetail = this.areaDetail.detail;

      data.peiId = store.getters.SelectedPei;
      data.areaId = areaDetail.areaId;
      data.timeDebtedQty =
        typeof data.timeDebtedQty === 'string'
          ? parseInt(data.timeDebtedQty)
          : data.timeDebtedQty;
      data.durationQty = areaDetail.durationQty || 0;

      if (this.model.peiDurationCode) {
        data.peiDurationCode = this.model.peiDurationCode.id;
      } else {
        data.peiDurationCode = areaDetail.peiDurationCode || 103;
      }

      if (this.model.peiFrequencyCode) {
        data.peiFrequencyCode = this.model.peiFrequencyCode.id;
      } else {
        data.peiFrequencyCode = areaDetail.peiFrequencyCode || 101;
      }

      data.companionFlag = this.transportationModel.acompanyCode;
      data.specialEquipmentCode = this.transportationModel.specialEquipmentCode;
      data.justification = this.transportationModel.justification;

      data.departureCode = this.transportationModel.departureCode;
      data.locationCode = this.transportationModel.placeCode;

      //cuando seleccionan No directamente, no se carga este dato: analysisServiceId
      data.analysisServiceId = this.requiredTransportation?.analysisServiceId;

      data.departureAddress = {
        ...this.transportationModel.departure,
        locationTypeId: data.departureCode,
      };
      data.placeAddress = {
        ...this.transportationModel.place,
        locationTypeId: data.locationCode,
      };

      data.startDate = this.transportationModel.startDate;
      data.endDate = this.transportationModel.endDate;

      data.millaje = Number(this.transportationModel.mileage);

      // avoid null values for ints type when saving transportation info
      this.deleteTransportNullProperty(data, 'departureAddress');
      this.deleteTransportNullProperty(data, 'placeAddress');

      if (!this.isUpdate) {
        await this.$ApiPost(
          'api/pei/savepeiserviceareaextendedschoolyear',
          data
        );
        this.isUpdate = true;
        this.isEditOrView = true;
      } else {
        await this.$ApiPut(
          'api/pei/updatepeiserviceareaextendedschoolyear',
          data
        );
      }
      store.commit('setFormDirty', { value: false });
      this.ShowToast(
        'Notificacón',
        'Los datos fueron guardado exitosamente',
        'success'
      );
    },
    // US 150589 — fetch parameter EnableTherapyServiceAeeOrRegressionSheetValidation
    // true: therapy service and regression sheet validations are active (block form if missing)
    // false: no validations, allow adding areas freely
    async loadEnableTherapyServiceAeeOrRegressionSheetValidation() {
      // skip loading if the regression sheet field is not even shown
      if (!this.showRegressionCompensatoryRequestNumberField) {
        return;
      }

      // cache guard — avoid fetching the parameter more than once per session
      if (
        this.hasTherapyServiceAeeOrRegressionSheetValidationEnabled !== null
      ) {
        return;
      }

      if (!this.academicYearId) {
        return;
      }

      const {
        data: parameterValue,
      } = await getSysparameterByNameAndAcademicYear(
        'EnableTherapyServiceAeeOrRegressionSheetValidation',
        this.academicYearId
      );

      this.hasTherapyServiceAeeOrRegressionSheetValidationEnabled =
        parameterValue?.value?.toLowerCase() === 'true';
    },
    deleteTransportNullProperty(data, propertyName = '') {
      if (data?.[propertyName]?.locationTypeId === null) {
        delete data[propertyName].locationTypeId;
      }

      if (data?.[propertyName]?.schoolTypeId === null) {
        delete data[propertyName].schoolTypeId;
      }
    },
    async loadTherapyDuration() {
      return await generalService.getDurations();
    },
    loadFrequencyType() {
      return this.$ApiGet('/api/pei/frequencyType');
    },
    async validate() {
      const isFormValid = await this.$refs.form.validate();
      return isFormValid;
    },
    async onChangeTranspInfo(item) {
      this.model.transportation.wasRequested = item.selectedAnswer;

      let programAreaId = this.model.programServiceAreaId;
      if (!programAreaId) {
        this.ShowToast(
          'Mensaje de validación',
          'Debe seleccionar un área',
          'error'
        );
        this.model.transportation.wasRequested = null;
        this.validate();
        return;
      }
      let areaId = this.areaDetail.detail.areaId;

      await this.$ApiPost(`api/pei/aeetransportrequest`, {
        peiId: store.getters.SelectedPei,
        programAreaId: programAreaId,
        areaId: areaId,
        answer: item.selectedAnswer,
        peiServiceTypeId: this.peiServiceTypeId,
      });

      this.isEditOrView = true;

      if (item.selectedAnswer) {
        await this.getTransportationInfo();
      }
    },
    onDepartureChange(id) {
      this.model.analysisServiceDepartureCode = id;
    },
    onLocationChange(id) {
      this.model.analysisServiceLocationCode = id;
    },
    onAccompanyChange(id) {
      this.model.companionFlag = id;
    },
    onSpecialEquipmentChange(id) {
      this.model.specialEquipmentCode = id;
    },
    onMillajeChange(value) {
      this.model.millaje = value;
    },

    onStartDateChange(value) {
      this.model.startDate = value;
    },
    onEndDateChange(value) {
      this.model.endDate = value;
    },
    async getTransportRequestQuestions() {
      if (this.requiredTransportation != null) {
        let idQuestionary = this.requiredTransportation.id;

        let response = await this.$ApiGet(
          `api/pei/gettransportrequestquestions/${store.getters.SelectedPei}/${idQuestionary}`,
          {
            peiServiceTypeId: this.peiServiceTypeId,
          }
        );

        this.transportRequestQuestion = response.data;
      }
    },
    async getTransportRequest() {
      if (
        !this.areaDetail ||
        !this.areaDetail.detail ||
        !this.areaDetail.detail.areaId
      )
        return;

      this.requiredTransportation = null;

      let programAreaId = this.model.programServiceAreaId;

      let areaId = this.areaDetail.detail.areaId;

      const { data: response } = await this.$ApiGet(
        `api/pei/getaeetransportrequest/${store.getters.SelectedPei}/${programAreaId}/${areaId}`
      );

      if (response && response !== '') {
        this.requiredTransportation = response;
        this.showTransportType = response.state;

        if (response.status == null) {
          this.questionnaireStatus = 'Pendiente';
        } else {
          this.questionnaireStatus = response.state
            ? 'Completado'
            : 'Pendiente';
          //-1. show warning message to speak up 1. No required, 2. Regular, 3.Carrier, 4.Scholarship
          if (response.status.id == 0) {
            this.transportType = '-1';
            this.model.peiTransportationStatus = null;
          } else {
            this.transportType = response.status.id + '';
            this.model.peiTransportationStatus = response.status.id;
          }
        }
      }
    },
    onAddServiceClick() {
      this.evaluations.push(
        {
          id: 1,
          name: 'Psicométrica',
          date: '17/ene./2018',
          adminBy: 'Aida Mendoza Rodríguez',
        },
        {
          id: 2,
          name: 'Psicología',
          date: '20/may./2016',
          adminBy: 'Especialista por Contrato',
        }
      );
    },
    onShowEvaluationHistoryHandler() {},
    onAddDocumentClick() {
      this.documents.push({
        id: 1,
        name: 'Archivo_nombre.pdf',
        document: 'Archivo_nombre.pdf',
        category: 'Plan de Intervención',
      });
    },
    async onUpdateQuestionnarie() {
      this.requiredTransportation = null;
      await this.getTransportRequest();
    },
    onEditHandler() {
      if (this.isDraft) {
        this.getTransportRequestQuestions();
      }
      this.showTransportType = false;
      this.questionnaireValid = true;
    },
    async getPeiServiceAreasAEE() {
      let self = this;
      let programServiceAreaId = this.model.programServiceAreaId || 0;

      await self
        .$ApiGet(
          '/api/pei/getpeiserviceareasaee/' +
            this.peiId +
            '/' +
            programServiceAreaId
        )
        .then((res) => {
          self.areaList = res.data ? res.data : [];
        })
        .catch((err) => {
          self.response = err;
        });
    },
    selectData(item) {
      if (!item) return;

      this.model.timeDebtedQty = item.timeDebtedQty;
      this.model.isCompensatoryTime = item.isCompensatoryTime;
      this.model.fromDate = new Date(item.fromDate);
      this.model.toDate = new Date(item.toDate);
      this.model.extendedDescription = item.extendedDescription;
      this.model.modalityName = item.modalityName;
      this.model.peiFrequency = item.peiFrequency;
      this.model.programServiceAreaId = item.programServiceAreaId;
      this.model.analysisServiceDepartureCode = item.departureCode;
      this.model.analysisServiceLocationCode = item.locationCode;
      this.model.companionFlag = item.companionFlag;
      this.model.specialEquipmentCode = item.specialEquipmentCode;
      this.model.millaje = item.millaje;
      this.model.peiDurationCode =
        this.durationList.length > 0
          ? this.durationList.find((dur) => dur.id === item.peiDurationCode)
          : new Object();
      this.model.peiFrequencyCode =
        this.frequencyList.length > 0
          ? this.frequencyList.find((feq) => feq.id === item.peiFrequencyCode)
          : new Object();
      this.model.startDate = item.startDate;
      this.model.endDate = item.endDate;
      this.model.analysisServiceControlVisualCode =
        item.analysisServiceControlVisualCode;
      this.model.justification = item.justification;

      this.transportationModel.readOnlyDate = true;

      store.dispatch('setPeiTransportationInfo', {
        departureCode: item.departureCode,
        placeCode: item.locationCode,
        specialEquipmentCode: item.specialEquipmentCode,
        acompanyCode: item.companionFlag,
        millaje: item.millaje,
        startDate: this.model.fromDate,
        endDate: this.model.toDate,
        readOnlyDate: true,
      });
    },
    goBack() {
      this.$root.$router.push('/pei/detail?tab=Tab7');
    },
    async getTransportationInfo() {
      await this.getTransportRequest();
      await this.getTransportRequestQuestions();

      let transportInfo = await store.state.peiTransportationInfo;
      if (transportInfo) {
        this.transportationModel.departureCode = transportInfo.departureCode;
        this.transportationModel.acompanyCode = transportInfo.acompanyCode;
        this.transportationModel.endDate = transportInfo.endDate;
        this.transportationModel.startDate = transportInfo.startDate;
        this.transportationModel.placeCode = transportInfo.placeCode;
        this.transportationModel.mileage = transportInfo.millaje;
        this.transportationModel.specialEquipmentCode =
          transportInfo.specialEquipmentCode;
        this.transportationModel.justification = this.model.justification;

        if (transportInfo.departureCode) {
          this.getDepartureData(transportInfo.departureCode);
        }

        if (transportInfo.placeCode) {
          this.getPlaceData(transportInfo.placeCode);
        }
      }
    },
    async getTransportationAddress(locationTypeId, addressTypeId) {
      if (!this.requiredTransportation) {
        return;
      }
      return await this.$ApiGet(
        `/api/pei/transportationaddressaee?programServiceAreaId=${this.model.programServiceAreaId}&locationTypeId=${locationTypeId}&addressTypeId=${addressTypeId}`
      );
    },
    async getDepartureData(code) {
      let { data } = await this.getTransportationAddress(
        code,
        transportationServiceAddressTypes.departure
      );
      this.transportationModel.departure = data;
    },
    async applyExtendedSchoolYearStartDateRule() {
      if (!this.academicYearId) {
        this.showRegressionCompensatoryRequestNumberField = false;
        return;
      }

      const { data } = await getSysparameterByNameAndAcademicYear(
        'EnableExtendedSchoolYearStartDate',
        this.academicYearId
      );
      const parameterDateRaw =
        data?.value ?? data?.staticValue ?? data?.Value ?? null;

      if (!parameterDateRaw) {
        this.showRegressionCompensatoryRequestNumberField = false;
        return;
      }

      const parsedParameterDate = moment(String(parameterDateRaw).trim(), [
        'YYYY/MM/DD',
        'YYYY/MM/DDTHH:mm:ss',
        'YYYY/MM/DDTHH:mm:ss.SSSZ',
        'DD/MM/YYYY',
        'D/M/YYYY',
      ]);
      if (!parsedParameterDate.isValid()) {
        this.showRegressionCompensatoryRequestNumberField = false;
        return;
      }

      this.showRegressionCompensatoryRequestNumberField =
        moment().startOf('day') >= parsedParameterDate.startOf('day');
    },
    getRegressionPlanillaMissingMessage() {
      const detail = this.areaDetail?.detail;

      const name =
        this.model.selectArea?.name ||
        detail?.serviceName ||
        detail?.programServiceArea ||
        'terapia';

      if (this.hasAnyEducativeServiceInAeeValue === false) {
        return `No es posible añadir el servicio de ${name} ya que no cuenta con un servicio Educativo en AEE`;
      }

      return `No es posible añadir el servicio de ${name} ya que no cuenta con una planilla de Regresión.`;
    },
    async loadRegressionCompensatoryRequestNumber() {
      await this.loadHasAnyEducativeServiceInAee();
      this.regressionCompensatoryRequestNumber = '';
      this.regressionCompensatoryRequestNumberLoaded = false;
      const disciplineTypeId = this.areaDetail?.detail?.disciplineTypeId;

      if (
        !this.canShowRegressionCompensatoryRequestNumberField ||
        !this.model.selectArea?.id ||
        !(disciplineTypeId > 0)
      ) {
        return;
      }

      const studentSieId =
        store.getters.SelectedStudent?.studentId ??
        store.getters['$_student/StudentSie'];

      if (!studentSieId || !this.academicYearId || !(disciplineTypeId > 0))
        return;

      try {
        const { data } = await this.$ApiGet(
          'api/pei/getregressioncompensatoryrequestnumber',
          {
            studentSieId,
            academicYearId: this.academicYearId,
            disciplineTypeId,
          }
        );

        if (typeof data === 'string' && data.trim() !== '') {
          this.regressionCompensatoryRequestNumber = data.trim();
        } else {
          this.regressionCompensatoryRequestNumber = '';
        }

        if (
          this.isDraft &&
          !this.isEditOrView &&
          // US 150589 — only show the blocking toast when validations are enabled
          this.hasTherapyServiceAeeOrRegressionSheetValidationEnabled &&
          // if not educative service, show the message
          !this.isEducativeService &&
          this.isRegressionPlanillaBlockingForm
        ) {
          this.ShowToast(
            'Atención',
            this.getRegressionPlanillaMissingMessage(),
            'error'
          );
        }
      } finally {
        this.regressionCompensatoryRequestNumberLoaded = true;
      }
    },
    async getPlaceData(code) {
      let { data } = await this.getTransportationAddress(
        code,
        transportationServiceAddressTypes.place
      );
      this.transportationModel.place = data;
    },
    async loadHasAnyEducativeServiceInAee() {
      if (this.hasAnyEducativeServiceInAeeValue !== null) {
        return;
      }

      const peiId = store.getters.SelectedPei;
      if (!peiId) {
        this.hasAnyEducativeServiceInAeeValue = false;
        return;
      }

      const { data } = await generalService.hasAnyEducativeServiceInAee(peiId);
      this.hasAnyEducativeServiceInAeeValue = data === true;
    },
  },
  computed: {
    academicYearId() {
      return store.getters.getPeiInfo?.academicYearId;
    },
    // US 150589 — regression sheet field is only visible when validations are enabled
    canShowRegressionCompensatoryRequestNumberField() {
      return (
        this.showRegressionCompensatoryRequestNumberField &&
        this.hasTherapyServiceAeeOrRegressionSheetValidationEnabled
      );
    },
    isDraft: function() {
      return this.selectedPeiStatus == peiStatus.Borrador;
    },
    canShowTransportationSection() {
      // JSF: US46525 - always show tranport section for types Educative and other.
      const serviceTypesBypass = [
        this.peiAnalysisService.Otros,
        this.peiAnalysisService.Educativo,
      ];
      if (
        serviceTypesBypass.some((typeId) => this.peiServiceTypeId == typeId)
      ) {
        return true;
      }

      const services = this.model.serviceStatusesInfo;
      const saee = services.find((x) => !x.isRemPro);
      const inactiveStatuses = [
        AdmissionStatuses.NoVinculado,
        AdmissionStatuses.NoVigenteTraslado,
        AdmissionStatuses.NoVigenteAlta,
        AdmissionStatuses.NoVigenteBajas,
        AdmissionStatuses.NoVigenteFinAnioEscolar,
        AdmissionStatuses.ReferidoRechazado,
        AdmissionStatuses.ReferidoAlDirectorCSEE,
        AdmissionStatuses.NoVinculadoDenegadoRemPro,
        AdmissionStatuses.NoVigenteEgreso,
        AdmissionStatuses.NoVigenteCambioDeServicio,
      ];
      // if it's not active then don't show the transportation's section
      let canShow =
        saee !== undefined &&
        !inactiveStatuses.some((statusId) => statusId === saee.statusId);
      // then check if has contract (if apply)
      if (
        canShow &&
        saee.statusId === AdmissionStatuses.AprobadoEnRemedioProvisional
      ) {
        const rempro = services.find((x) => x.isRemPro);
        const hasContract = rempro.statusId > 0;
        canShow = hasContract && rempro?.typeOfPlace?.length > 0;
      } else {
        // check if it has a type of place
        canShow = canShow && saee?.typeOfPlace?.length > 0;
      }

      return (
        this.canShowServiceStatusSection &&
        (store.getters.HasPermission('pei.tab8.services.transportation') ||
          canShow)
      );
    },
    ...mapGetters({
      selectedPeiStatus: 'SelectedPeiStatus',
      peiServiceTypeId: 'getServiceTypeId',
      serviceTypeId: 'getAnalysisServiceId',
    }),
    isPS() {
      return store.getters.getIsPs;
    },
    canShowTransportationSectionForPS() {
      let canShow = this.model.isTransportationLogicActive
        ? this.canShowTransportationSection
        : !this.isPS;
      return canShow;
    },
    canShowServiceStatusSection() {
      return (
        this.isTherapyService &&
        this.peiServiceTypeId != this.peiAnalysisService.Otros &&
        this.model.isTransportationLogicActive
      );
    },
    isEducativeService() {
      return this.areaDetail?.detail?.isEducative;
    },
    isTherapyService() {
      return [
        this.peiAnalysisService.TerapiaDeHabla,
        this.peiAnalysisService.TerapiaOcupacional,
        this.peiAnalysisService.TerapiaPsicológica,
        this.peiAnalysisService.TerapiaFísica,
        this.peiAnalysisService.TerapiaOromotora,
        this.peiAnalysisService.TerapiaEducativa,
        this.peiAnalysisService.Otros,
      ].includes(this.peiServiceTypeId);
    },
    isTransportationLogicActive() {
      return this.model.isTransportationLogicActive === true;
    },
    showQuestion() {
      return this.academicYearId < academicYears.Y2023_2024;
    },
    areas() {
      if (this.areaList.length > 0) {
        const areas = this.areaList.map((a) => a.areas);
        return areas;
      }
      return [];
    },
    peiServiceTypeId() {
      return this.areaDetail?.detail?.disciplineTypeId;
    },
    getAreaSelected() {
      return this.model.selectArea;
    },
    areaDetail() {
      const selectArea = this.model.selectArea;
      if (selectArea != null && this.areaList.length > 0) {
        const detail = this.areaList.find(
          (d) => d.detail.programServiceAreaId === selectArea.id
        );

        return detail;
      }
      return {};
    },
    isCompensatoryTime() {
      return this.model.isCompensatoryTime;
    },
    isEducativo() {
      return (
        this.areaDetail &&
        this.areaDetail.detail &&
        this.peiProgramAreas.Educativo ==
          this.areaDetail.detail.disciplineTypeId
      );
    },
    isRequiredTransportQuestionnary() {
      let notRequiredTransportCodes = [3, 4];
      return !notRequiredTransportCodes.some(
        (code) => code == this.model.analysisServiceControlVisualCode
      );
    },
    isRegressionPlanillaBlockingForm() {
      // if the field is not shown then not block the form, return false
      if (this.canShowRegressionCompensatoryRequestNumberField === false) {
        return false;
      }
      // US 150589 — if validations are not enabled, allow submission without regression sheet
      if (!this.hasTherapyServiceAeeOrRegressionSheetValidationEnabled) {
        return false;
      }
      // if it is educative then not block the form, return false
      if (this.isEducativeService) {
        return false;
      }

      // if it has no educative service saved in db then block the form, return true
      if (this.hasAnyEducativeServiceInAeeValue === false) {
        return true;
      }

      // if the number is loaded and is empty then block the form, return true
      if (
        this.regressionCompensatoryRequestNumberLoaded &&
        this.regressionCompensatoryRequestNumber === ''
      ) {
        return true;
      }

      const blockForm =
        this.canShowRegressionCompensatoryRequestNumberField &&
        this.isDraft &&
        !this.isEditOrView &&
        !!this.model.selectArea?.id &&
        this.regressionCompensatoryRequestNumber === '';

      return blockForm;
    },
  },
  watch: {
    async 'model.selectArea'() {
      await this.initDataService();
    },
    areaDetail: {
      async handler() {
        if (this.areaDetail?.detail) {
          this.selectData(this.areaDetail.detail);
          this.getTransportationInfo();
        }
        await this.loadRegressionCompensatoryRequestNumber();
      },
    },
    showRegressionCompensatoryRequestNumberField: {
      async handler() {
        await this.loadRegressionCompensatoryRequestNumber();
      },
    },
    isCompensatoryTime() {
      if (!this.isCompensatoryTime) this.model.timeDebtedQty = 0;
    },
    'transportationModel.departureCode'(value) {
      if (value) {
        this.getDepartureData(value);
      }
    },
    'transportationModel.placeCode'(value) {
      if (value) {
        this.getPlaceData(value);
      }
    },
  },
  async mounted() {
    await this.applyExtendedSchoolYearStartDateRule();
    Promise.all([
      this.loadEnableTherapyServiceAeeOrRegressionSheetValidation(),
      this.loadHasAnyEducativeServiceInAee(),
    ]);

    const { data: therapyData } = await this.loadTherapyDuration();
    if (therapyData) {
      this.durationList = therapyData;
    }

    const { data: frequencyData } = await this.loadFrequencyType();
    if (frequencyData) {
      this.frequencyList = frequencyData;
    }

    this.model.selectArea = null;
    const areaExtended = this.$store.state.areaExtendedSelected;

    this.isEditOrView = false;
    this.model.programServiceAreaId = 0;
    if (areaExtended != null) {
      this.isEditOrView = true;
      this.isUpdate = true;
      this.model.selectArea = {
        id: areaExtended.programServiceAreaId,
        name: areaExtended.serviceName,
        sortOrder: 0,
      };
      this.model.programServiceAreaId = areaExtended.programServiceAreaId;
    }

    if (store.state.areaExtendedSelected) {
      this.model.transportation =
        store.state.areaExtendedSelected.transportation;
    }

    await this.getPeiServiceAreasAEE();
    if (
      this.areaDetail &&
      this.areaDetail.detail &&
      this.areaDetail.detail.areaId &&
      this.model.programServiceAreaId != null
    ) {
      await this.getTransportationInfo();
    }

    if (this.$refs.transportation != null) {
      this.$refs.transportation.selectedAnswer = this.model.transportation.wasRequested;
    }

    store.commit('setSaveMethod', this.save);
    store.commit('setResetOriginalDataMethod', () => {});
  },
};
</script>

<style scoped>
.panel-transporte {
  width: 1217px;
  height: 74px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.rounded-circle {
  text-align: center;
  width: 41px;
  height: 41px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #ff7058;
  opacity: 1;
}

.icon-bus {
  vertical-align: -webkit-baseline-middle;
  width: 22px;
  height: 22px;
  color: #ff7058;
}

.end-green-line {
  border: 1px solid #2db782;
  opacity: 1;
}

.tab {
  font-weight: 400;
}

.input-group {
  margin-left: 10px;
}
.number-text {
  width: 100px;
  margin-left: 10px;
}

.left-space {
  padding-left: 30px !important;
}

.accordion >>> .card-header {
  margin-bottom: -3px !important;
}

.accordion >>> .question-element {
  margin-top: -11px !important;
}
</style>
